/* Terms / 18+ checkbox above the checkout button (snippets/cart-subtotal.liquid).
   IVIN 2026-10-12: the cart re-renders #AjaxCartSubtotal with fresh server HTML after every change (quantity +/−,
   remove, discount), which reset the box to unticked and disabled checkout again. The choice now lives in
   sessionStorage for this visit and is restored each time a fresh copy connects. Checkout stays blocked until the
   box is ticked: the button is rendered `disabled` and only enabled from a ticked box. Storage blocked (private
   mode): the box simply isn't remembered. */
if (typeof customElements.get('terms-checkbox') === 'undefined') {

  const TOS_KEY = 'ivin_tos_ok';
  const readTos = () => { try { return window.sessionStorage.getItem(TOS_KEY) === '1'; } catch (e) { return false; } };
  const writeTos = (ok) => {
    try {
      if (ok) window.sessionStorage.setItem(TOS_KEY, '1');
      else window.sessionStorage.removeItem(TOS_KEY);
    } catch (e) { /* storage blocked: nothing to remember */ }
  };

  class TermsAndConditionsToggle extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      if (!this.checkbox) return;

      if (readTos()) this.checkbox.checked = true;
      this.#toggleCheckoutButton();

      if (this._wired) return;
      this._wired = true;
      this.checkbox.addEventListener('change', () => {
        writeTos(this.checkbox.checked);
        // the cart page can hold two copies (page + drawer): keep them in step
        document.querySelectorAll('terms-checkbox input[type="checkbox"]').forEach((box) => {
          if (box !== this.checkbox) box.checked = this.checkbox.checked;
        });
        this.#toggleCheckoutButton();
      });
    }

    #toggleCheckoutButton() {
      document.querySelectorAll('#CheckOut').forEach(button => {
        button.disabled = !this.checkbox.checked;
      });
    }
  }

  customElements.define('terms-checkbox', TermsAndConditionsToggle);

}
